import { Threshold as ThresholdScale } from '@antv/scale';
export const Threshold = (options) => {
    return new ThresholdScale(options);
};
Threshold.props = {};
//# sourceMappingURL=threshold.js.map